interface LoadingSpinnerProps {
  /** Optional message below the spinner */
  message?: string;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to center in full screen height */
  fullScreen?: boolean;
  className?: string;
}

export default function LoadingSpinner({
  message,
  size = 'md',
  fullScreen = false,
  className = '',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
  };

  return (
    <div
      className={`flex flex-col items-center justify-center ${
        fullScreen ? 'min-h-screen' : 'py-12'
      } ${className}`}
    >
      <div
        className={`animate-spin rounded-full border-2 border-db-border border-t-biscayne ${sizeClasses[size]}`}
      />
      {message && (
        <p className="mt-4 text-[14px] text-db-text-3">{message}</p>
      )}
    </div>
  );
}
